export function logDailyEvent(e) {
  //logging room events on console for tracking
  console.log("[daily.co event]", e.action);
}
